import { Component, Input, OnChanges } from '@angular/core';

import {
  Account,
  AccountSegmentSelection,
} from '@libs/src/models/account.model';
import { Group, GroupCustomSegment } from '@libs/src/models/group.model';
import { getMembership } from '@main-client/src/app/account/account.helpers';

import flatten from 'lodash-es/flatten';
import includes from 'lodash-es/includes';

@Component({
  selector: 'app-connection-summary-account-info',
  templateUrl: './connection-summary-account-info.component.html',
})
export class ConnectionSummaryAccountInfoComponent implements OnChanges {
  @Input() account: Account;
  @Input() group: Group;
  connectionHighlightsCustomSegments: string[] = [];
  connectionHighlightsRole: string;

  ngOnChanges(): void {
    const accountMembership = getMembership(
      this.account?.groups,
      this.group._id,
    );
    const accountRole = accountMembership?.role;
    const accountSegmentSelections =
      accountMembership?.segment_selections || [];
    const customSegmentSelectableForIntroductionGoals =
      this.group.custom_segments?.filter(
        (segment: GroupCustomSegment) =>
          segment.is_selectable_for_user_introduction_goals,
      ) || [];
    const customSegmentIdsSelectableForIntroductionGoals =
      customSegmentSelectableForIntroductionGoals.map(
        (segment: GroupCustomSegment) => segment._id,
      );
    this.connectionHighlightsCustomSegments = flatten(
      accountSegmentSelections
        .filter((selection: AccountSegmentSelection) =>
          includes(
            customSegmentIdsSelectableForIntroductionGoals,
            selection.custom_segment,
          ),
        )
        .map((selection: AccountSegmentSelection) => {
          return 0 < selection.multiselected_nodes?.length
            ? selection.multiselected_nodes
            : [selection.node];
        }),
    );
    this.connectionHighlightsRole = accountRole;
  }
}
